// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Cpw6","validationTips":"StatementDescriptor_validationTips__2UbV-"};